import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../product/components/templates/Layout'
import TableManage from '../../product/views/Settings/TableSettings/TableManage'

const BannerImage = (props) => {
    const [fieldValue, setFieldValue] = useState([
        {
            label: 'Desktop Banner Image *',
            type: 'uploadDropZone',
            accept: 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: 'Add a banner image with aspect ratio of 8:4',
            class: 'col-sm-6 col-12',
            name: 'image',
            is_required: true,
        },
        {
            label: 'Mobile Banner Image',
            type: 'uploadDropZone',
            accept: 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: 'Add a banner image with aspect ratio of 8:3',
            class: 'col-sm-6 col-12',
            name: 'image_mobile',
            is_required: false,
        },
        {
            label: 'Title',
            type: 'text',
            placeholder: 'Enter the title',
            class: 'col-sm-6 col-12',
            name: 'title',
            isRequired: false,
        },
        {
            label: 'Description',
            type: 'textarea',
            placeholder: 'Enter the description',
            class: 'col-12',
            name: 'description',
            isRequired: false,
        },
        {
            label: 'Button label',
            type: 'text',
            placeholder: 'Enter the button label',
            class: 'col-sm-6 col-12',
            name: 'button_label',
            isRequired: false,
        },
        {
            label: 'Button link',
            type: 'text',
            placeholder: 'Enter the button link',
            class: 'col-sm-6 col-12',
            name: 'link',
            isRequired: false,
        },
        {
            label: 'Button color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'color',
            isRequired: false,
        },
    ])

    return (
        <Layout>
            <TableManage
                variableName="allHomeBanner"
                tableName="home_banner"
                tableHeading="Banner Image"
                arrayValue={fieldValue}
                ignoreField={{
                    enabled: 1,
                    field: 'active',
                    value: 2,
                }}
            ></TableManage>
        </Layout>
    )
}

export default BannerImage
